export const paymentMethod = {
  creditCard: 'creditCard',
  bankAccount: 'bankAccount'
};
